import React, {useCallback, useContext} from 'react';

import ThumbsUp from '~/src/components/svg/action/ThumbsUp';

import {SettingsContext} from '~/src/components/context/SettingsContext';
import {classNames} from '~/src/utilities/helpers/css';
import initPolyglot from '~/src/utilities/libs/polyglot';

import css from './RatingItem.module.scss';
import i18nStrings from './RatingItem.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

const RatingItem = ({question, isUpRated = false, isDownRated = false, onRating}) => {
    const onUpRating = useCallback(() => onRating(question, true), []);
    const onDownRating = useCallback(() => onRating(question, false), []);

    const {siteArea} = useContext(SettingsContext);

    const numUpRatings = question.ratings.up + (isUpRated ? 1 : 0);
    const numDownRatings = question.ratings.down + (isDownRated ? 1 : 0);
    const numTotalRatings = numUpRatings + numDownRatings;

    const percentUpRatings = (100 * numUpRatings) / numTotalRatings;
    const percentDownRatings = (100 * numDownRatings) / numTotalRatings;
    const percentUpRatingsRounded = Math.round(percentUpRatings);
    const percentDownRatingsRounded = Math.round(percentDownRatings);

    const itemClassName = classNames(css, 'item', siteArea, {isUpRated, isDownRated});

    return (
        <div className={itemClassName} data-testid="RatingItem">
            <div className={css.infoContainer}>
                <span className={css.label}>{question.label}</span>

                {(isUpRated || isDownRated) && (
                    <React.Fragment>
                        <span className={css.totalRatings}>{getTranslation('ratings', {smart_count: numTotalRatings})}</span>
                        <div className={css.resultsContainer}>
                            <div className={css.resultsData}>
                                <span className={`${css.ratingIcon} ${css.downRated}`}>
                                    <ThumbsUp
                                        primaryClassName={css.primaryColor}
                                        secondaryClassName={css.secondaryColor}
                                        tertiaryClassName={css.tertiaryColor}
                                    />
                                </span>
                                <div className={css.resultsBar}>
                                    <div className={css.resultsBarDown} style={{width: `${percentDownRatingsRounded}%`}}></div>
                                </div>
                                <span className={css.ratingIcon}>
                                    <ThumbsUp
                                        primaryClassName={css.primaryColor}
                                        secondaryClassName={css.secondaryColor}
                                        tertiaryClassName={css.tertiaryColor}
                                    />
                                </span>
                            </div>
                            <div className={css.resultsNumbers}>
                                <span className={css.downRatings} title={numDownRatings}>
                                    {percentDownRatingsRounded}%
                                </span>
                                <span className={css.upRatings} title={numUpRatings}>
                                    {percentUpRatingsRounded}%
                                </span>
                            </div>
                        </div>
                    </React.Fragment>
                )}
            </div>

            <div className={css.thumbButtons}>
                <button className={css.downRating} onClick={onDownRating}>
                    <ThumbsUp primaryClassName={css.primaryColor} secondaryClassName={css.secondaryColor} tertiaryClassName={css.tertiaryColor} />
                </button>
                <button className={css.upRating} onClick={onUpRating}>
                    <ThumbsUp primaryClassName={css.primaryColor} secondaryClassName={css.secondaryColor} tertiaryClassName={css.tertiaryColor} />
                </button>
            </div>
        </div>
    );
};

export default RatingItem;
